import LogoWoo from '../../images/logo-technologies/logo-woo.webp'
import LogoStripe from '../../images/logo-technologies/logo-stripe.webp'
import LogoPaypal from '../../images/logo-technologies/logo-paypal.webp'
import LogoFlutter from '../../images/logo-technologies/logo-flutter.webp'
import LogoReact from '../../images/logo-technologies/logo-react.webp'
import LogoShopify from '../../images/logo-technologies/logo-shopify.webp'
import LogoQuickbooks from '../../images/logo-technologies/logo-quickbooks.webp'

const TechnologyStack = () => {
    return (
        <section className="technology-stack">
            <div className="bgr-noise"></div>
            <div className="technology-stack-wrapper">
                <h3>Technology <span className="text-violet-green">stack</span>.</h3>
                <p>Sorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>
                
                <div className="technology-logo-list">
                    <div className="tech-logo-item"> <img src={LogoWoo} alt="WooCommerce" loading='lazy' /> </div>
                    <div className="tech-logo-item"> <img src={LogoStripe} alt="Stripe" loading='lazy' /> </div>
                    <div className="tech-logo-item"> <img src={LogoPaypal} alt="Paypal" loading='lazy' /> </div>
                    <div className="tech-logo-item"> <img src={LogoFlutter} alt="Flutter" loading='lazy' /> </div>
                    <div className="tech-logo-item"> <img src={LogoReact} alt="React" loading='lazy' /> </div>
                    <div className="tech-logo-item"> <img src={LogoShopify} alt="Shopify" loading='lazy' /> </div>
                    <div className="tech-logo-item"> <img src={LogoQuickbooks} alt="Quickbooks" loading='lazy' /> </div>
                </div>
            </div>
        </section>
    );
  }
  
  export default TechnologyStack;